import React, { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar";
import Card from "react-bootstrap/Card";
import DataTable from "react-data-table-component";
import axios from "axios";
import * as FaIcons from "react-icons/fa";
import Cargando from "../../components/cargando";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import SinPermisos from "./../../components/sinpermisos";
import Nav from "react-bootstrap/Nav";

const url = "https://api.dacapo.com.ve/public/lecciones";
const urldelete = "https://api.sstrade.us/public/usuariosdelete";
const urleditar = "https://api.sstrade.us/public/usuariosedit";

const Lecciones = () => {
  //////////////Datos de Usuario Logueado/////////////////////////
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem("loginUser");
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON);
      setUsers(user);
    }
  }, []);

  //////////////Iniciando Status data//////////////////////////
  const [data, setData] = useState([]);

  const [datosSeleccionados, setDatosSeleccionados] = useState({
    id: "",
    nombre: "",
    descripcion: "",
    ubicacion: "",
    fecha: "",
    hora: "",
    contacto:"",
    telefono:"",
    precio: "",
    url_img: ""
  });

  /////////////////Datatable/////////////////////////////////

  const paginationComponentOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  const [pending, setPending] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setData(data);
      setPending(false);
    }, 100);
    return () => clearTimeout(timeout);
  });

  const columns = [
    {
      name: "Accion",
      button: true,
      cell: (row) => (
        <Nav>
          <button
            onClick={() => {
              setDatosSeleccionados(row);
              abrirModalEditaruser();
            }}
            className="btn btn-default"
          >
            <FaIcons.FaRegEdit />{" "}
          </button>{" "}
          &nbsp;&nbsp;&nbsp;
          {/* <button
            className="btn btn-default"
            onClick={() => {
              setDatosSeleccionados(row);
              abrirModalEditar();
            }}
          >
            <FaIcons.FaTrash />
          </button> */}
        </Nav>
      ),
    },
    {
      name: "Id",
      selector: (row) => row.id,
      defaultSortAsc: true,
      sortable: true,
    },
    {
      name: "Catedra",
      selector: (row) => row.nombreclase,
    },
    {
      name: "Clase",
      selector: (row) => row.nombre,
    },
    {
      name: "Precio USD",
      selector: (row) => row.precio,
    },
    {
      name: "Cod Profesor",
      selector: (row) => row.idprofesor,
    },
    {
      name: "Modalidad",
      selector: (row) => row.modalidad,
    },
    
   
  ];
  /////////////Buscar datos//////////////////////////////////
  const [buscar, setBuscar] = useState("");
  const [filtrobuscar, setFiltroBuscar] = useState([]);

  useEffect(() => {
    // eslint-disable-next-line
    const result = data.filter((resultdata) => {
      if (
        resultdata.nombre.toLowerCase().match(buscar.toLowerCase()) ||
        resultdata.ubicacion.toLowerCase().match(buscar.toLowerCase())
      ) {
        return resultdata;
      }
    });
    setFiltroBuscar(result);
  }, [buscar, data]);

  ///////////////Insertar Datos//////////////////////////////////

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDatosSeleccionados((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 1000000) {
      // 1000 KB = 1000000 bytes
      alert("El archivo no debe ser más pesado de 1000 KB");
      e.target.value = null; // Clear the file input
    } else {
      setDatosSeleccionados((prevState) => ({
        ...prevState,
        url_img: file,
      }));
    }
  };

  const [Error, setError] = useState(false);

  /*   const peticionPost = async () => {
    delete datosSeleccionados.id;
    console.log(datosSeleccionados);
    await axios.post(url, datosSeleccionados).then(res => {
      peticionGet();
      setError(false);
     
    })
      .catch((err) => {
        setError(true);
        
      })
  }
 */
  //////////////Editar datos/////////////////////////////////////
  const [modalEditar, setModalEditar] = useState(false);
  const abrirModalEditar = () => {
    setModalEditar(true);
  };

  const peticionPut = async () => {
    // eslint-disable-next-line no-template-curly-in-string
    await axios
      .delete(urldelete + "/" + datosSeleccionados.id, datosSeleccionados)
      .then((response) => {
        peticionGet();
        setError(false);
        setModalEditar(false);
      })
      .catch((err) => {
        setError(true);
        setModalEditar(false);
      });
  };

  const [modalEditaruser, setModalEditaruser] = useState(false);
  const abrirModalEditaruser = () => {
    setModalEditaruser(true);
  };

  const peticionPutuser = async () => {
    console.log(datosSeleccionados);
    await axios
      .put(url + "/" + datosSeleccionados.id, datosSeleccionados)
      .then((response) => {
        peticionGet();
        setError(false);
        setModalEditaruser(false);
      })
      .catch((err) => {
        console.log(err);
        setError(true);
        setModalEditaruser(false);
      });
  };

  const [modalcrearevento, setModalcrearevento] = useState(false);
  const abrirModalcrearevento = () => {
    setModalcrearevento(true);
  };

  const peticioncrearevento = async () => {
    const formData = new FormData();
    for (const key in datosSeleccionados) {
      formData.append(key, datosSeleccionados[key]);
    }

    console.log(datosSeleccionados);
    await axios
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response.data);
        peticionGet();
        setError(false);
        setModalcrearevento(false);
      })
      .catch((err) => {
        console.log(err);
        setError(true);
        setModalcrearevento(false);
      });
  };

  /////////////Mostrar datos//////////////////////////////////
  const peticionGet = async () => {
    await axios.get(url).then((response) => {
      setData(response.data);
      setFiltroBuscar(response.data);
    });
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    await peticionGet();
  }, []);

  /////////////////////////////////////////////////////////////////
  if (users.rol !== undefined) {
    if (users.rol === "admin") {
      return (
        <div>
          <div className="Categorias">
            <Sidebar>
              <Card>
                <Card.Header className="bg-dark text-white" as="h3">
                  <div className="row">
                    <div className="col-md-2">Clases</div>
                    <div className="col-md-10 text-left">
                     {/*  <button
                        className="btn btn-info"
                        onClick={() => {
                          abrirModalcrearevento();
                        }}
                      >
                        <FaIcons.FaPlus /> Añadir Instrumentos
                      </button> */}
                    </div>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Card.Title>Clases registrados</Card.Title>
                  {Error && (
                    <div className="alert alert-danger">
                      {
                        <strong>
                          Error: El nombre ya existe! intente con otro nombre.
                        </strong>
                      }
                    </div>
                  )}
                  <p> Clases registrados en el sistema.</p>
                  <DataTable
                    columns={columns}
                    data={filtrobuscar}
                    noDataComponent="No hay elementos a mostrar"
                    progressPending={pending}
                    progressComponent={<Cargando />}
                    pagination
                    paginationComponentOptions={paginationComponentOptions}
                    subHeader
                    subHeaderComponent={
                      <input
                        type="text"
                        placeholder="Buscar"
                        className="w-25 form-control"
                        value={buscar}
                        onChange={(e) => setBuscar(e.target.value)}
                      />
                    }
                  />

                  <Modal isOpen={modalEditar}>
                    <ModalHeader>
                      <div>
                        <h4>Eliminar usuario </h4>
                      </div>
                    </ModalHeader>
                    <ModalBody>
                      <input
                        className="form-control"
                        readOnly
                        type="hidden"
                        name="id"
                        value={datosSeleccionados.id}
                        onChange={onchange}
                      />
                      <div className="form-group">
                        <h5>
                          ¿Desea eliminar al usuario #{datosSeleccionados.id}?{" "}
                        </h5>
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <button
                        className="btn btn-dark"
                        onClick={() => setModalEditar(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={() => peticionPut()}
                      >
                        Eliminar
                      </button>
                    </ModalFooter>
                  </Modal>

                  <Modal isOpen={modalEditaruser}>
                    <ModalHeader>
                      <div>
                        <h5>Editar Clase {datosSeleccionados.username}</h5>
                      </div>
                    </ModalHeader>
                    <ModalBody>
                      <div className="form-group">
                     {/*    <input
                          className="form-control"
                          readOnly
                          type="hidden"
                          name="id"
                          value={datosSeleccionados.id}
                          onChange={handleChange}
                        />
                        {datosSeleccionados.url_img && (
                          <img
                            src={datosSeleccionados.url_img}
                            alt="Imagen del evento"
                            className="img-fluid mb-3"
                            style={{ width: '200px', height: '200px' }}
                          />
                        )}<br />
                        <br /> */}
                        <label>Nombre</label>
                        <input
                          className="form-control"
                          type="text"
                          name="nombre"
                          value={datosSeleccionados.nombre}
                          onChange={handleChange}
                        />
                        <br /> <br />
                        <label>Precio Clase</label>
                        <input
                          className="form-control"
                          type="text"
                          name="precio"
                          value={datosSeleccionados.precio}
                          onChange={handleChange}
                        />
                        
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <button
                        className="btn btn-dark"
                        onClick={() => setModalEditaruser(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        className="btn btn-success"
                        onClick={() => peticionPutuser()}
                      >
                        Actualizar
                      </button>
                    </ModalFooter>
                  </Modal>

                  <Modal isOpen={modalcrearevento} className="modal-lg">
                    <ModalHeader>
                      <div>
                        <h5>Crear instrumento</h5>
                      </div>
                    </ModalHeader>
                    <ModalBody>
                      <div className="form-group row">
                        <div className="col-md-12">
                          <label>Nombre</label>
                          <input
                            className="form-control"
                            type="text"
                            name="nombre"
                            value={datosSeleccionados.nombre}
                            onChange={handleChange}
                          />
                        </div>
                        
                      </div>
                      
                      <div className="form-group">
                        <label>Imagen (máximo 1000 KB)</label>
                        <input
                          className="form-control"
                          type="file"
                          name="url_img"
                          onChange={handleFileChange}
                        />
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <button
                        className="btn btn-dark"
                        onClick={() => setModalcrearevento(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        className="btn btn-success"
                        onClick={() => peticioncrearevento()}
                      >
                        Crear evento
                      </button>
                    </ModalFooter>
                  </Modal>
                </Card.Body>
              </Card>
            </Sidebar>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <Sidebar>
            <SinPermisos />
          </Sidebar>
        </div>
      );
    }
  } else {
    return (
      <div>
        <Sidebar>
          <SinPermisos />
        </Sidebar>
      </div>
    );
  }
};

export default Lecciones;
